<template>
    <div>
        <CrosspromOptions ref="crosspromOptions" :data="data" @setData="setData"/>
    </div>
</template>
<script>
import Heading from '../../../components/Theme/Heading'
import CrosspromOptions from '../../../components/Ecommerce/CrosspromOptions'
import {ref} from '@vue/composition-api'

export default {
    name: 'Step3',
    components: {
        Heading,
        CrosspromOptions
    },
    props: {
        data: Object,
    },
    setup(props, {emit}){
        const crosspromOptions = ref()
        const validateFields = () => {
            crosspromOptions.value.validateFields()
        }

        const setData = data => emit('setData', data)

        return {
            crosspromOptions,
            validateFields,
            setData
        }
    }
}
</script>
